<script context="module" lang="ts">
  export type Quote = {
    logo: any;
    quote: string;
    name: string;
    title: string;
    href: string;
    paddingTop?: number;
    paddingBottom?: number;
  };
</script>

<script lang="ts">
  export let quotes: Quote[];
</script>

<section class="marketing-container mt-24 mb-9">
  <div class="marketing-contained-negate-ml marketing-contained-negate-mr">
    <div
      class="flex flex-col lg:flex-row border border-x-0 lg:border-x border-light-green/30 lg:rounded-lg"
    >
      {#each quotes as quote}
        <div
          class="flex flex-col flex-1 items-stretch py-6 px-10 gap-y-6 border-b lg:border-b-0 lg:border-r last:border-r-0 last:border-b-0 border-light-green/30"
        >
          <div>
            <a href={quote.href} target="_blank" rel="noreferrer">
              <img
                src={quote.logo}
                alt="customer logo"
                height={32}
                class="h-8"
                style:padding-top={quote.paddingTop
                  ? quote.paddingTop + "px"
                  : 0}
                style:padding-bottom={quote.paddingBottom
                  ? quote.paddingBottom + "px"
                  : 0}
              />
            </a>
          </div>
          <div class="flex flex-col gap-y-6 justify-end h-full">
            <p class="text-light-green/60">“{quote.quote}”</p>
            <div class="text-sm">
              <span class="text-light-green">{quote.name}</span>,
              <span class="text-light-green/60">{quote.title}</span>
            </div>
          </div>
        </div>
      {/each}
    </div>
  </div>
</section>
